module.exports = {
  title: "คำเตือน",
  description: `ข้อตกลงในการให้บริการ AutoRebalance , Backtest และ Forwardtest ไม่สามารถการันตีผลลัพธ์หรือผลกำไรในอนาคตได้ การใช้งานดังกล่าวมีความเสี่ยง ไม่แนะนำให้ใช้งานหากไม่ทำการศึกษาข้อมูล ข้อจำกัดและยอมรับเงื่อนไข ผู้ใช้งานควรยอมรับความเสี่ยงก่อนติดสินใจใช้งาน สอบถามข้อมูลโทร +66891769303`,
  button_text: "ฉันเข้าใจและยอมรับ",
};
